import { api } from '../axios';
import Mongo from './Mongo';
import Authentication from './Authentication';
import {
  SimulationWhere,
  GenerateSimulationResponse,
  SimulationObj,
} from 'src/types/Modules/Simulation';
import { EveResponse, ObjectiveHistory } from '../../types';
import Area from './Area';

const SIMULATION_ENDPOINT = '/simulation';
const SIMULATION_GENERATE_ENDPOINT = 'contest-new/simulation/generate';
const SIMULATION_SAVE_ENDPOINT = '/simulation/save';
const SIMULATION_UPDATE_DURATION_ENDPOINT = 'simulation/update/duration';

class Simulations extends Mongo {
  public async fetch({
    where,
    page = 1,
    max = 10,
    sortBy = [['_updated', 'desc']],
  }: {
    where: SimulationWhere;
    page?: number;
    max?: number;
    sortBy?: [string, string][];
  }): Promise<EveResponse<SimulationObj[]> | undefined> {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      const flattenQuery = this.flattenMongoQuery({
        query: {
          ...where,
          user_email: loginData.user.email,
          contest_id: {
            $in: [loginData.plan.current_contest],
          },
        },
      }) as unknown;
      const response = await api.get<EveResponse<SimulationObj[]>>(
        SIMULATION_ENDPOINT,
        {
          params: {
            page,
            max_results: max,
            where: flattenQuery,
            sort: this.parseSortArr(sortBy),
          },
          headers: {
            ContestId: loginData.plan.current_contest,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  public async generate(): Promise<GenerateSimulationResponse | undefined> {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      const response: GenerateSimulationResponse = await api.post(
        SIMULATION_GENERATE_ENDPOINT,
        {
          contest_id: loginData.contest._id,
          user_email: loginData.user.email,
        }
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  public async updateDuration({
    id,
    duration,
  }: {
    id: string;
    duration: number;
  }): Promise<void> {
    try {
      const loginData = Authentication.loggedUser();
      const loggedArea = Area.loggedArea();
      if (!loginData) return;
      await api.post(
        SIMULATION_UPDATE_DURATION_ENDPOINT,
        {
          duration,
          simulation_id: id,
        },
        {
          headers: {
            'X-Org-Id': loggedArea.group,
            UserEmail: loginData.user?.email,
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
  }
  public async save({
    answer_statistics,
    duration,
    answers,
    simulation_id,
    status = 'started',
  }: {
    answer_statistics: {
      correct: number;
      wrong: number;
      blanc: number;
    };
    status?: string;
    duration: number;
    answers: ObjectiveHistory[];
    simulation_id: string;
  }): Promise<unknown | undefined> {
    try {
      const area = Area.loggedArea();
      const loginData = Authentication.loggedUser();
      const response: unknown = await api.post(
        SIMULATION_SAVE_ENDPOINT,
        {
          answer_statistics,
          duration,
          answers,
          contest_id: loginData?.contest._id,
          simulation_id,
          user_email: loginData?.user?.email,
          date_made: new Date(),
          status,
        },
        {
          headers: {
            'X-Org-Id': area.group,
            UserEmail: loginData?.user?.email,
          },
        }
      );
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return response;
    } catch (error) {}
  }
}

export default new Simulations();
